"use strict";

var _taggedTemplateLiteral = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation UserSignUpMutation($user: UserCreateInput!, $authProfileId: ID) {\n    userSignUp(user: $user, authProfileId: $authProfileId) {\n      id\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var graphql_tag_1 = __importDefault(require("graphql-tag"));

exports.SIGNUP_MUTATION = graphql_tag_1.default(_templateObject());